import axios from 'axios';
import TokenService from './TokenService';
import jwt_decode from 'jwt-decode';

const AxiosInterceptor = () => {
  const tokenService = TokenService.getService();
  axios.interceptors.request.use(
    async config => {
      console.log(config.url);
      console.log(config.data);
      let apiUrl = new URL(config.url);
      if (apiUrl.pathname.includes('/auth')) return config;

      let accessToken = tokenService.getAccessToken();
      if (
        accessToken === 'undefined' ||
        accessToken === null ||
        tokenService.isTokenExpired(jwt_decode(accessToken))
      ) {
        // make a new service call to retreive the token
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/auth/token`,
            {
              guid: `${process.env.REACT_APP_GUID}`
            },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          );
          accessToken = res.data.accessToken;
          tokenService.setToken(accessToken);
        } catch (e) {
          console.log(e);
        }
      }

      //set the headers for the backend API
      config.headers['Authorization'] = `Bearer ${accessToken}`;
      config.headers['Content-Type'] = `application/json`;

      return config;
    },
    error => {
      console.log(error);
      Promise.reject(error);
    }
  );

  // Add a response interceptor
  axios.interceptors.response.use(
    response => {
      console.log('Happy intercepting in Response');
      return response;
    },
    error => {
      Promise.reject(error);
    }
  );
};

export default AxiosInterceptor;
